import { render } from "./Vans.vue?vue&type=template&id=234d8b00"
import script from "./Vans.vue?vue&type=script&lang=js"
export * from "./Vans.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__